<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    size="xl"
    @hideModal="hideModal()"
  >
    <template #header>
      {{ $t('views.agreements.list.options.createAgreementItems') }}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col>
          <b-col cols="12">
            <p>{{ $t('views.agreements.list.createAgreementItemsCollection') }}:</p>
            <ul>
              <li v-for="(agreement, index) in getAgreements" :key="'idClient_'+index">
                {{ agreement.idClientName }}
              </li>
            </ul>
          </b-col>
          <AgreementAdditionalItems
            :create-agreement-items-multi="true"
            :data="agreement"
            :violations="[]"
            :is-invalid="() => {return false}">
          </AgreementAdditionalItems>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <button type="button" class="mt-2 btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button
            type="button"
            class="btn btn-success float-right"
            @click="createAgreementItems()"
          >
            {{$t('buttons.accept')}}
          </button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AgreementAdditionalItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementAdditionalItems'

export default {
  name: 'CreateAgreementAdditionalItemsModal',
  components: {
    AgreementAdditionalItems,
    BaseModal
  },

  props: ['id', 'idCollection'],

  data () {
    return {
      agreement: {
        agreementAdditionalItems: []
      }
    }
  },
  created () {
    this.fetchDocumentTemplateOptions()
  },
  computed: {
    ...mapGetters({
      isVisible: 'agreements/createAgreementAdditionalItemsModal/isVisible',
      response: 'agreements/createAgreementAdditionalItemsModal/response',
      getAgreements: 'agreements/list/getAgreementsForMassEdit'
    })
  },
  watch: {
    isVisible (val) {
      if (val) {
        this.fetchAgreements({ idAgreements: this.idCollection })
      }
    },
    response () {
      this.hideModal()
    }
  },
  methods: {
    createAgreementItems () {
      this.createAgreementItemsForCollection({
        body: {
          'agreementAdditionalItems': this.agreement.agreementAdditionalItems,
          'agreements': this.idCollection,
          'additional': 1
        }
      })
    },
    hideModal () {
      this.$emit('reset')
      this.toggleCreateAgreementItemsModal()
      this.agreement.agreementAdditionalItems = []
    },
    ...mapMutations({
      toggleCreateAgreementItemsModal: 'agreements/createAgreementAdditionalItemsModal/toggleModal'
    }),
    ...mapActions({
      fetchDocumentTemplateOptions: 'agreements/list/fetchDocumentTemplateOptions',
      createAgreementItemsForCollection: 'agreements/createAgreementAdditionalItemsModal/createAgreementItemsForCollection',
      fetchAgreements: 'agreements/list/fetchAgreementsForMassEdit'
    })
  }
}
</script>
